import {
	blankCurrent
} from '../helpers/user'

export const user = ({user={}})=>{
	if (!user.getIn(['current', '_id']))
		return blankCurrent

	return user.current
}

export const userStatus = ({user={}})=>{
	return user.status
}

export const errorReason = ({user={}})=>{
	return user.errorReason
}

export const isNotAuthorized = ({user={}})=>
	user.getIn(['status', 'authorized'])=='no'

export const isLogged = ({user={}})=>
	user.status=='loaded'

export const isPro = ({user={}})=>
	user.getIn(['current', 'pro']) ? true : false

//"definitely free" — only true once the profile resolved. `current.pro`
//reads falsy for the blank pre-load profile too, so gating on !isPro
//alone would briefly mis-gate Pro users whose entitlement is still in
//flight. Unknown → fail open; the server enforces anyway.
export const isFree = ({user={}})=>
	user.getIn(['status', 'authorized']) == 'yes' && !user.getIn(['current', 'pro'])

export const subscription = ({user={}})=>user.subscription
